// Polyfills for modern APIs used by pdfjs-dist v5 that are missing in older browsers

// Promise.withResolvers (Chrome 119+, Safari 17.4+)
const _Promise = Promise as typeof Promise & {
  withResolvers?: <T>() => {
    promise: Promise<T>
    resolve: (value: T | PromiseLike<T>) => void
    reject: (reason?: unknown) => void
  }
}

if (typeof _Promise.withResolvers !== 'function') {
  _Promise.withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void
    let reject!: (reason?: unknown) => void
    const promise = new Promise<T>((res, rej) => {
      resolve = res
      reject = rej
    })
    return { promise, resolve, reject }
  }
}

// URL.parse (Chrome 126+, Safari 18+) — used for annotation links
const _URL = URL as typeof URL & { parse?: (url: string, base?: string) => URL | null }

if (typeof _URL.parse !== 'function') {
  _URL.parse = function (url: string, base?: string) {
    try {
      return new URL(url, base)
    } catch {
      return null
    }
  }
}

// Promise.try (Chrome 128+, Safari 18+)
// Type already cast above with withResolvers, add try to the intersection
declare global {
  interface PromiseConstructor {
    withResolvers<T>(): {
      promise: Promise<T>
      resolve: (value: T | PromiseLike<T>) => void
      reject: (reason?: unknown) => void
    }
    try<T>(fn: () => T | PromiseLike<T>): Promise<T>
  }
}

if (typeof _Promise.try !== 'function') {
  _Promise.try = function <T>(fn: () => T | PromiseLike<T>) {
    return new Promise<T>((resolve) => resolve(fn()))
  }
}

export {}
